import { render, staticRenderFns } from "./CheckoutPaymentsPayPalPlus.vue?vue&type=template&id=74233a00&"
import script from "./CheckoutPaymentsPayPalPlus.vue?vue&type=script&lang=js&"
export * from "./CheckoutPaymentsPayPalPlus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports